import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { PaymentItemPopupComponent } from './payment-item-dialog.component';
import { PaymentItemDeletePopupComponent } from './payment-item-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class PaymentItemResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const paymentItemPopupRoute: Routes = [
    {
        path: 'payment-item-new/:idPayment',
        component: PaymentItemPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.paymentItem.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'payment-item/:id/edit',
        component: PaymentItemPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.paymentItem.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'payment-item/:id/delete',
        component: PaymentItemDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.paymentItem.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment-item/payment-item.route.ts